module.exports = __webpack_public_path__ + "static/media/red-dot.7e275b7e.svg";